import React, { Component } from 'react'
import Propiedad from '../../../../../containers/Sections/Propiedades/propiedad'
import MapPropiedad from '../../../../Maps'

export default class MapList extends Component {
  render () {

    const { properties, categories } = this.props;

    if (!properties){
      return (
        <div className="hoteles-container list-view">
          no hay propiedades, ocurrio algun error
        </div>
      )
    }
    else{

      return (
        <div className="container-propiedades map-list">
          <div className="col-md-6 ">
            <MapPropiedad datos={properties} categories={categories} type="PropiedadesMapList" width={600} height={585}/> 
          </div>
          <div className="col-md-6 hidden-xs">
            <div className="map-results">
              {properties.map((item, index) =>
                <div className="col-xs-12 col-sm-6 col-md-11 col-lg-6" key={index}>
                  <Propiedad property={item} />
                </div>
              )}
            </div>
          </div>
        </div>
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Sections/Propiedades/PropiedadesList/Map/index.js